export const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
export const analyser = audioCtx.createAnalyser();
analyser.fftSize = 256;